import { createContext, useContext, Dispatch, SetStateAction } from 'react';
import type { Settings } from '@app-types';

export interface SettingsContextValue {
    settings: Settings | null;
    setSettings: Dispatch<SetStateAction<Settings | null>>;
}

const SettingsContext = createContext<SettingsContextValue | null>(null);

const useSettingsContext = () => {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error(`useSettingsContext must be used within a SettingsProvider`);
    }
    return context;
};

export { SettingsContext, useSettingsContext };
